import React from "react";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Card, InputLabel, SimpleCardHeading, TextareaField} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useFormContext} from "react-hook-form";
import {orderPlacementValidation, PosOrderForm} from "@/data/entities/order";
import {emptyToNull, getInputValidationProps} from "@/data/Validation";

/**
 * Note of the customer, printed on the kitchen and courier receipt.
 */
const NoteCard = ({isPending}: OrderEditorTabProps) => {
    const intl = useIntl();
    const {register, formState: {errors}} = useFormContext<PosOrderForm>();

    return (
        <Card
            header={
                <CardHeader>
                    <SimpleCardHeading title={<FormattedMessage id={"note"}/>}/>
                </CardHeader>
            }
        >
            <TextareaField
                rows={3}
                label={
                    <InputLabel hint={<FormattedMessage id={"optional"}/>}>
                        <FormattedMessage id={"noteForKitchenAndCourier"}/>
                    </InputLabel>
                }
                placeholder={intl.formatMessage({id: "notePlaceholder"})}
                disabled={isPending}
                error={errors.note?.message}
                {...register("note", {
                    ...getInputValidationProps(orderPlacementValidation.note, intl),
                    setValueAs: emptyToNull,
                })}
            />
        </Card>
    );
};

export default NoteCard;